export default __webpack_public_path__ + "static/media/profile_photo.8c475cfa.JPG";